export default __webpack_public_path__ + "static/media/laptop14.b3ceb28b.jpeg";